import { AdminsListPage } from '@/pages/admins-list'
import { AlbumCollectionCreatePage } from '@/pages/album-collection-create'
import { AlbumCollectionEditPage } from '@/pages/album-collections-edit'
import { AlbumCreatePage } from '@/pages/album-create'
import { AlbumEditPage } from '@/pages/album-edit'
import { AuthorEditPage } from '@/pages/author-edit'
import { AuthorsListPage } from '@/pages/authors-list'
import { CollectionsListPage } from '@/pages/collections-list'
import { DonationsByDateListPage } from '@/pages/donations-by-date-list'
import { DonationsByUserIdPage } from '@/pages/donations-by-user-list'
import { FeedbackPage } from '@/pages/feedback'
import { JingleCollectionCreatePage } from '@/pages/jingle-collection-create'
import { JingleCollectionEditPage } from '@/pages/jingle-collection-edit'
import { JinglesListPage } from '@/pages/jingles-list'
import { GreetingsPage } from '@/pages/settings-greetings'
import { MyWavePage } from '@/pages/settings-my-wave'
import { NotificationCreatePage } from '@/pages/settings-notification-create'
import { NotificationEditPage } from '@/pages/settings-notification-edit'
import { NotificationsListPage } from '@/pages/settings-notifications-list'
import { PolicyPage } from '@/pages/settings-policy'
import { StatisticsPage } from '@/pages/statistics'
import { TagsListPage } from '@/pages/tags-list'
import { TrackCreatePage } from '@/pages/track-create'
import { TrackEditPage } from '@/pages/track-edit'
import { TracksListPage } from '@/pages/tracks-list'
import { $sessionRole } from '@/shared/api'
import { ROUTES, UserRolesEnum } from '@/shared/config'
import { ErrorResult } from '@/shared/ui'
import {
  AudioOutlined,
  CreditCardOutlined,
  CustomerServiceOutlined,
  FilterOutlined,
  MessageOutlined,
  SettingOutlined,
  StockOutlined,
  UserOutlined,
  UsergroupAddOutlined,
} from '@ant-design/icons'
import { combine, createStore } from 'effector'
import { Navigate } from 'react-router-dom'

import type { IRoute, ITab } from './types'

export const $routes = createStore<IRoute[]>([
  // MAIN
  {
    path: ROUTES.MAIN.ROOT,
    component: <Navigate to={ROUTES.AUDIO.ROOT} replace />,
  },
  // AUDIO
  {
    path: ROUTES.AUDIO.ROOT,
    component: <TracksListPage />,
  },
  {
    path: ROUTES.AUDIO.CREATE,
    component: <TrackCreatePage />,
  },
  {
    path: ROUTES.AUDIO.EDIT,
    component: <TrackEditPage />,
  },
  // COLLECTIONS
  {
    path: ROUTES.COLLECTIONS.ROOT,
    component: <CollectionsListPage />,
  },
  {
    path: ROUTES.COLLECTIONS.CREATE_ALBUM,
    component: <AlbumCreatePage />,
  },
  {
    path: ROUTES.COLLECTIONS.EDIT_ALBUM,
    component: <AlbumEditPage />,
  },
  {
    path: ROUTES.COLLECTIONS.CREATE_ALBUM_COLLECTION,
    component: <AlbumCollectionCreatePage />,
  },
  {
    path: ROUTES.COLLECTIONS.EDIT_ALBUM_COLLECTION,
    component: <AlbumCollectionEditPage />,
  },
  // AUTHORS
  {
    path: ROUTES.AUTHORS.ROOT,
    component: <AuthorsListPage />,
  },
  {
    path: ROUTES.AUTHORS.EDIT,
    component: <AuthorEditPage />,
  },
  // JINGLES
  {
    path: ROUTES.JINGLES.ROOT,
    component: <JinglesListPage />,
  },
  {
    path: ROUTES.JINGLES.CREATE_COLLECTION,
    component: <JingleCollectionCreatePage />,
  },
  {
    path: ROUTES.JINGLES.EDIT_COLLECTION,
    component: <JingleCollectionEditPage />,
  },
  // TAGS
  {
    path: ROUTES.TAGS.ROOT,
    component: <TagsListPage />,
    roles: [UserRolesEnum.SUPERADMIN],
  },
  {
    path: ROUTES.STATS.ROOT,
    component: <StatisticsPage />,
  },
  // DONATIONS
  {
    path: ROUTES.DONATIONS.ROOT,
    component: <DonationsByDateListPage />,
    roles: [UserRolesEnum.SUPERADMIN],
  },
  {
    path: ROUTES.DONATIONS.USER,
    component: <DonationsByUserIdPage />,
    roles: [UserRolesEnum.SUPERADMIN],
  },
  {
    path: ROUTES.FEEDBACK.CHAT,
    component: <FeedbackPage />,
  },
  // SETTINGS
  // NOTIFICATIONS
  {
    path: ROUTES.SETTINGS.NOTIFICATIONS,
    component: <NotificationsListPage />,
  },
  {
    path: ROUTES.SETTINGS.CREATE_NOTIFICATION,
    component: <NotificationCreatePage />,
  },
  {
    path: ROUTES.SETTINGS.EDIT_NOTIFICATION,
    component: <NotificationEditPage />,
  },
  // MY WAVE
  {
    path: ROUTES.SETTINGS.MY_WAVE,
    component: <MyWavePage />,
  },
  // GREETINGS
  {
    path: ROUTES.SETTINGS.GREETINGS,
    component: <GreetingsPage />,
  },
  // POLICY
  {
    path: ROUTES.SETTINGS.POLICY,
    component: <PolicyPage />,
  },

  // ADMINS
  {
    path: ROUTES.ADMINS.ROOT,
    component: <AdminsListPage />,
    roles: [UserRolesEnum.SUPERADMIN],
  },
])

export const $allTabs = createStore<ITab[]>([
  {
    text: 'Контент',
    icon: CustomerServiceOutlined,
    children: [
      {
        text: 'Аудиофайлы',
        path: ROUTES.AUDIO.ROOT,
      },
      {
        text: 'Коллекции',
        path: ROUTES.COLLECTIONS.ROOT,
      },
    ],
  },
  {
    path: ROUTES.AUTHORS.ROOT,
    text: 'Авторы',
    icon: UserOutlined,
  },
  {
    path: ROUTES.JINGLES.ROOT,
    text: 'Джинглы',
    icon: AudioOutlined,
  },
  {
    path: ROUTES.TAGS.ROOT,
    text: 'Жанры',
    icon: FilterOutlined,
  },
  {
    text: 'Настройки',
    icon: SettingOutlined,
    children: [
      {
        text: 'Push уведомления',
        path: ROUTES.SETTINGS.NOTIFICATIONS,
      },
      {
        text: 'Моя Чистая Волна',
        path: ROUTES.SETTINGS.MY_WAVE,
      },
      {
        text: 'Приветственные экраны',
        path: ROUTES.SETTINGS.GREETINGS,
      },
      {
        text: 'Документы',
        path: ROUTES.SETTINGS.POLICY,
      },
    ],
  },
  {
    path: ROUTES.STATS.ROOT,
    text: 'Статистика',
    icon: StockOutlined,
  },
  {
    path: ROUTES.DONATIONS.ROOT,
    text: 'Эквайринг',
    icon: CreditCardOutlined,
  },
  {
    path: ROUTES.ADMINS.ROOT,
    text: 'Администраторы',
    icon: UsergroupAddOutlined,
  },
  {
    path: ROUTES.FEEDBACK.ROOT,
    text: 'Обратная связь',
    icon: MessageOutlined,
  },
])
export const $availableRoutes = combine($routes, $sessionRole, (routes, role) =>
  routes.map((route) => {
    let result = route
    if (!role || (route.roles && !route.roles.includes(role))) {
      result = {
        ...route,
        component: (
          <ErrorResult
            customConfig={{
              status: '403',
            }}
          />
        ),
      }
    }
    return result
  }),
)

export const $pageHeaderTabs = combine(
  $routes,
  $allTabs,
  $sessionRole,
  (routes, tabs, role) => {
    return tabs
      .map((tab) => {
        if (tab.path) {
          const route = routes.find((r) => r.path === tab.path)
          if (!role || (route?.roles && !route.roles.includes(role))) {
            return null
          }
          return tab
        }

        if (tab.children) {
          const filteredChildren = tab.children.filter((child) => {
            if (!child.path) return true
            const route = routes.find((r) => r.path === child.path)
            if (!role || (route?.roles && !route.roles.includes(role)))
              return false
            return true
          })
          if (filteredChildren.length === 0) return null
          return { ...tab, children: filteredChildren }
        }

        return tab
      })
      .filter(Boolean) as ITab[]
  },
)
